import styled from 'styled-components';

export const Container = styled('div')`
  width: 100%;
  background-color: ${(props) => props.theme.colors.groupInputsSeletorWrapperColor};
  position: relative;
  border-radius: ${(props) => (props.exibir ? '10px 10px 0px 0px' : '10px')};
  border: 0;
  padding: 0 20px;
  cursor: pointer;
  transition: border-radius 0.2s linear;

  button.seletor-head {
    background-color: transparent;
    color: ${(props) => props.theme.colors.text.placeholder};//TODO: nome da cor incoerente
    cursor: pointer;
    border-width: 0;

    display: flex;
    justify-content: space-between;
    height: 36px;
    align-items: center;
    width: 100%;

    .title {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: ${(props) => props.theme.colors.text.placeholder}; //TODO: nome da cor incoerente
      font-size: 1.2rem;
      font-weight: 300;
    }
  }

  span.radio-button-label {
    color: ${(props) => props.theme.colors.text.default};
  }

  .seletor-body {
    position: absolute;
    display: ${(props) => (props.exibir ? 'block' : 'none')};
    visibility: ${(props) => (props.exibir ? 'visible' : 'hidden')};
    background-color: ${(props) => props.theme.colors.seletorSimpleSeletorBodyColor};
    max-height: calc(35px * 10 + 1px);
    height: auto;
    overflow: auto;
    border-radius: 0px 0px 20px 20px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
    z-index: 2;
    font-size: 1.2rem;
    width: calc(100% + 2px);
    left: -1px;
    margin-top: 0 !important;
    margin-left: 0 !important;

    .body-closer-wrapper {
      display: flex;
      align-items: center;
      color: #610082;
      font-size: 1.2rem;

      .selector-title {
        display: none;
        color: ${(props) => props.theme.colors.selectorTitle};
      }

      .body-closer {
        cursor: pointer;
        display: none;
      }
    }

    .selector-data-wrapper {
      padding: 0 20px;
      .icon {
        color: ${(props) => props.theme.colors.avataTextColor};
      }
    }
    .option-wrapper{
      border-top: 1px solid ${(props) => props.theme.colors.UploadSurveyOptionsBorderColor};
      &:first-of-type {
        border-top: 0;
      }
    }
    .selector-search-wrapper {
      position: sticky;
      top: 0;
      background: ${(props) => props.theme.colors.seletorSearchBackgroundcolor};
      padding: 0 20px;
    }

    .selector-search-wrapper ::placeholder {
        color: ${(props) => props.theme.colors.text.placeholder};
    }

    @media (max-width: 586px) {
      position: fixed;
      left: 0;
      top: 0;
      min-width: auto;
      width: 100vw;
      height: 100vh;
      max-height: 100vh;
      z-index: 99999999999999999;
      padding: 20px;

      .settings-closer {
        font-size: 2.6rem;
        font-weight: bold;
        display: block;
      }

      .body-closer-wrapper {
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
        color: rgb(97, 0, 130);
        font-size: 1.4rem;

        .selector-title {
          display: block;          
        }

        .body-closer {
          ${(props) => props.theme.colors.selectorBodyCloser};
          font-size: 2.6rem;
          font-weight: bold;
          display: block;
          padding-right:0;
        }

        margin-bottom: 20px;
      }
    }
  }

  &.dark {
    background-color: ${(props) => props.theme.colors.UploadSurveyInputColor};
    border: 1px solid ${(props) => props.theme.colors.UploadSurveyInputColor};

    button.seletor-head {
      background-color: ${(props) => props.theme.colors.UploadSurveyInputColor};

      > .title {
        color: ${(props) => props.theme.colors.titleButtonSeletorHead};
      }
    }

    .seletor-body {
      background: ${(props) => props.theme.colors.UploadSurveyInputColor};
      span {
        color: ${(props) => props.theme.colors.text.default};
      }

      .icon > * {
        color: ${(props) => props.theme.colors.searchIconColor};
      }
    }

    .selector-search-wrapper {
      background: inherit;
      color: ${(props) => props.theme.colors.text.placeholder};
    }

     input {
        background:  ${(props) => props.theme.colors.configSelectorDarkInputTextColor};
      }
  }

  .icondown.active {
    transform: rotate(-180deg);
    transition: 0.2s linear;
    color: #00c6c9;
  }

  .icondown.noActive {
    transform: rotate(0deg);
    transition: 0.2s linear;
    color: #00c6c9;
  }
`;
